<div class="page-wrapper">
  <div class="page-header-with-back"
    style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 24px;">
    <div style="display: flex; align-items: center; gap: 15px;">
      <button type="button" class="form-back-btn" (click)="goBack()"
        style="background: white; border: 1px solid #eaeaea; font-size: 18px; cursor: pointer; color: #0a376e; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 8px; transition: all 0.3s ease; box-shadow: 0 2px 4px rgba(0,0,0,0.02);">
        <i class="bi" [ngClass]="userLang === 'ar' ? 'bi-chevron-right' : 'bi-chevron-left'"></i>
      </button>
      <div class="page-title" style="margin-bottom: 0;">{{ 'interviewSetup.title' | translate }}</div>
    </div>

    <div class="header-actions" *ngIf="viewMode">
      <button type="button" class="header-edit-btn" (click)="switchToEditMode()">
        {{ 'Edit' | translate }}
      </button>
      <button type="button" class="header-copy-btn" (click)="copyInterviewLink()" *ngIf="interviewType === 'PUBLIC'"
        [class.copied]="isCopied" title="{{ viewData?.interviewLink }}">
        {{ (isCopied ? 'dash.copied' : 'dash.copyLink') | translate }}
        <span class="header-copy-icon-wrap">
          <i class="bi" [ngClass]="isCopied ? 'bi-check2' : 'bi-copy'"></i>
        </span>
      </button>
    </div>
  </div>
  <!-- Standalone Banner & Details (create mode only) -->
  <ng-container *ngIf="(isStandalone || canEditJobPostFields) && !viewMode">
    <div class="standalone-banner"
      style="background-color: #f5f6fa; border: 1px solid #e1e3ea; border-radius: 8px; padding: 16px; margin-bottom: 24px; display: flex; gap: 12px; align-items: flex-start;">
      <i class="bi bi-info-circle-fill" style="color: #3b5998; font-size: 20px;"></i>
      <div>
        <h3 style="margin: 0 0 4px; font-size: 16px; font-weight: 600; color: #d65555;">{{ 'interviewSetup.standaloneTitle' | translate }}: {{
          standaloneInterviewTitle }}</h3>
        <p style="margin: 0 0 8px; font-size: 14px; color: #5a6a80;">{{ 'interviewSetup.standaloneDesc' | translate }}</p>
        <a href="#"
          style="font-size: 14px; font-weight: 600; color: #003366; text-decoration: none; display: inline-flex; align-items: center; gap: 4px;">
          {{ 'interviewSetup.viewJobPostPlans' | translate }} <i class="bi bi-box-arrow-up-right" style="font-size: 12px;"></i>
        </a>
      </div>
    </div>

    <div class="section linked-job-card">
      <h2 class="interview-section-title" style="margin-bottom: 20px;">{{ 'interviewSetup.details' | translate }}</h2>

      <div style="display: flex; gap: 20px; flex-wrap: wrap; max-width: 837px;">
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.interviewTitle' | translate }}</label>
          <input type="text" class="form-input" [(ngModel)]="interviewTitle" [placeholder]="'interviewSetup.interviewTitlePlaceholder' | translate" />
        </div>
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.positionTitle' | translate }}</label>
          <input type="text" class="form-input" [(ngModel)]="positionTitle" [placeholder]="'interviewSetup.enterPositionTitle' | translate" />
        </div>
      </div>

      <div style="display: flex; gap: 20px; flex-wrap: wrap; max-width: 837px; margin-top: 20px;">
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.positionDepartment' | translate }}</label>
          <input type="text" class="form-input" [(ngModel)]="positionDepartment"
            [placeholder]="'interviewSetup.enterPositionDepartment' | translate" />
        </div>
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.positionJobType' | translate }}</label>
          <input type="text" class="form-input" [(ngModel)]="positionJobType" [placeholder]="'interviewSetup.enterPositionJobType' | translate" />
        </div>
      </div>

      <div style="display: flex; gap: 20px; flex-wrap: wrap; max-width: 837px; margin-top: 20px;">
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.positionLevel' | translate }}</label>
          <div class="custom-select" [class.open]="positionJobLevelDropdownOpen">
            <div class="custom-select-trigger form-input" (click)="togglePositionJobLevelDropdown($event)">
              <span [class.select-placeholder]="!positionJobLevel">{{ selectedPositionJobLevelLabel }}</span>
              <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <div class="custom-select-dropdown" *ngIf="positionJobLevelDropdownOpen" (click)="$event.stopPropagation()">
              <div *ngFor="let level of positionJobLevelOptions" class="custom-select-option"
                [class.option-active]="positionJobLevel === level.value"
                (click)="selectPositionJobLevel(level.value, $event)">
                {{ level.label }}
              </div>
            </div>
          </div>
        </div>
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.jobPostTitle' | translate }}</label>
          <input type="text" class="form-input" [(ngModel)]="jobPostTitle" [placeholder]="'interviewSetup.enterJobPostTitle' | translate" />
        </div>
      </div>

      <div class="field-group" style="max-width: 837px; margin-top: 20px;">
        <label class="field-label">{{ 'interviewSetup.description' | translate }}</label>
        <input type="text" class="form-input" [(ngModel)]="description" [placeholder]="'interviewSetup.enterDescription' | translate" />
      </div>
    </div>
  </ng-container>

  <!-- Standalone Edit Mode -->
  <ng-container *ngIf="editMode && !selectedJobPostId">
    <div class="section linked-job-card">
      <h2 class="interview-section-title" style="margin-bottom: 20px;">{{ 'interviewSetup.details' | translate }}</h2>

      <div style="display: flex; gap: 20px; flex-wrap: wrap; max-width: 837px;">
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.interviewTitle' | translate }}</label>
          <input type="text" class="form-input" [(ngModel)]="interviewTitle" [placeholder]="'interviewSetup.interviewTitlePlaceholder' | translate" />
        </div>
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.positionTitle' | translate }}</label>
          <input type="text" class="form-input" [(ngModel)]="positionTitle" [placeholder]="'interviewSetup.enterPositionTitle' | translate" />
        </div>
      </div>

      <div style="display: flex; gap: 20px; flex-wrap: wrap; max-width: 837px; margin-top: 20px;">
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.positionDepartment' | translate }}</label>
          <input type="text" class="form-input" [(ngModel)]="positionDepartment"
            [placeholder]="'interviewSetup.enterPositionDepartment' | translate" />
        </div>
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.positionJobType' | translate }}</label>
          <input type="text" class="form-input" [(ngModel)]="positionJobType" [placeholder]="'interviewSetup.enterPositionJobType' | translate" />
        </div>
      </div>

      <div style="display: flex; gap: 20px; flex-wrap: wrap; max-width: 837px; margin-top: 20px;">
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.positionLevel' | translate }}</label>
          <div class="custom-select" [class.open]="positionJobLevelDropdownOpen">
            <div class="custom-select-trigger form-input" (click)="togglePositionJobLevelDropdown($event)">
              <span [class.select-placeholder]="!positionJobLevel">{{ selectedPositionJobLevelLabel }}</span>
              <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <div class="custom-select-dropdown" *ngIf="positionJobLevelDropdownOpen" (click)="$event.stopPropagation()">
              <div *ngFor="let level of positionJobLevelOptions" class="custom-select-option"
                [class.option-active]="positionJobLevel === level.value"
                (click)="selectPositionJobLevel(level.value, $event)">
                {{ level.label }}
              </div>
            </div>
          </div>
        </div>
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.jobPostTitle' | translate }}</label>
          <input type="text" class="form-input" [(ngModel)]="jobPostTitle" [placeholder]="'interviewSetup.enterJobPostTitle' | translate" />
        </div>
      </div>

      <div class="field-group" style="max-width: 837px; margin-top: 20px;">
        <label class="field-label">{{ 'interviewSetup.description' | translate }}</label>
        <input type="text" class="form-input" [(ngModel)]="description" [placeholder]="'interviewSetup.enterDescription' | translate" />
      </div>
    </div>
  </ng-container>

  <!-- VIEW MODE: Standalone (no jobPostId) — show position info + description -->
  <ng-container *ngIf="viewModeIsStandalone">
    <div class="section linked-job-card">
      <h2 class="interview-section-title" style="margin-bottom: 20px;">{{ 'interviewSetup.details' | translate }}</h2>

      <div style="display: flex; gap: 20px; flex-wrap: wrap; max-width: 837px;">
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.interviewTitle' | translate }}</label>
          <input type="text" class="form-input" [value]="interviewTitle" [disabled]="true" />
        </div>
        <div class="field-group" style="flex: 1; min-width: 250px;">
          <label class="field-label">{{ 'interviewSetup.positionTitle' | translate }}</label>
          <input type="text" class="form-input" [value]="positionTitle" [disabled]="true" />
        </div>
      </div>

      <div class="field-group" style="max-width: 837px;" *ngIf="positionJobLevel">
        <label class="field-label">{{ 'interviewSetup.positionLevel' | translate }}</label>
        <input type="text" class="form-input" [value]="selectedPositionJobLevelLabel" [disabled]="true" />
      </div>

      <div style="display: flex; gap: 20px; flex-wrap: wrap; max-width: 837px; margin-top: 20px;">
        <div class="field-group" style="flex: 1; min-width: 250px;" *ngIf="positionDepartment">
          <label class="field-label">{{ 'interviewSetup.positionDepartment' | translate }}</label>
          <input type="text" class="form-input" [value]="positionDepartment" [disabled]="true" />
        </div>
        <div class="field-group" style="flex: 1; min-width: 250px;" *ngIf="positionJobType">
          <label class="field-label">{{ 'interviewSetup.positionJobType' | translate }}</label>
          <input type="text" class="form-input" [value]="positionJobType" [disabled]="true" />
        </div>
      </div>

      <div style="display: flex; gap: 20px; flex-wrap: wrap; max-width: 837px; margin-top: 20px;">
        <div class="field-group" style="flex: 1; min-width: 250px;" *ngIf="jobPostTitle">
          <label class="field-label">{{ 'interviewSetup.jobPostTitle' | translate }}</label>
          <input type="text" class="form-input" [value]="jobPostTitle" [disabled]="true" />
        </div>
        <div class="field-group" style="flex: 1; min-width: 250px;" *ngIf="viewData?.description">
          <label class="field-label">{{ 'interviewSetup.description' | translate }}</label>
          <div class="description-html-view" [innerHTML]="viewData?.description"></div>
        </div>
      </div>

      <!-- Buy button removed from here — unified under "Link Count in edit/view mode" section below -->
    </div>
  </ng-container>

  <!-- Interview Title -->
  <div class="section" *ngIf="(!isStandalone && !viewMode) || editMode">
    <div class="field-group">
      <label class="field-label">{{ 'interviewSetup.interviewTitle' | translate }}</label>
      <input type="text" class="form-input" name="interviewTitle" [(ngModel)]="interviewTitle"
        [placeholder]="'interviewSetup.interviewTitlePlaceholder' | translate" />
    </div>
  </div>

  <!-- Linked Job Context (create mode OR view mode when jobPostId exists) -->
  <div class="section linked-job-card" *ngIf="(selectedJobPostId && !viewMode) || viewModeHasJobPost">
    <div class="linked-job-card-header">
      <h2 class="interview-section-title linked-job-title">{{ 'interviewSetup.linkedJobContext' | translate }}</h2>
      <span class="linked-job-link-icon" aria-hidden="true">🔗</span>
    </div>

    <div class="linked-job-grid">
      <div class="linked-job-row">
        <span class="linked-job-label">{{ 'interviewSetup.jobPost' | translate }}</span>
        <span class="linked-job-value">{{ selectedJobPostName }}</span>
      </div>
      <div class="linked-job-row">
        <span class="linked-job-label">{{ 'interviewSetup.position' | translate }}</span>
        <span class="linked-job-value">{{ selectedJobPostPosition }}</span>
      </div>
      <!-- Interview title row in view mode (no description when jobPostId exists) -->
      <div class="linked-job-row" *ngIf="viewModeHasJobPost">
        <span class="linked-job-label">{{ 'interviewSetup.interviewTitle' | translate }}</span>
        <span class="linked-job-value">{{ interviewTitle }}</span>
      </div>
    </div>
  </div>

  <!-- Language -->
  <div class="section">
    <h2 class="interview-section-title">{{ 'interviewSetup.language' | translate }}</h2>

    <div class="language-toggle">
      <button type="button" class="lang-btn" [class.active]="selectedLanguage === 'EN'"
        (click)="!viewMode && onLanguageChange('EN')" [class.disabled-btn]="viewMode">
        {{ 'interviewSetup.english' | translate }}
      </button>
      <button type="button" class="lang-btn" [class.active]="selectedLanguage === 'AR'"
        (click)="!viewMode && onLanguageChange('AR')" [class.disabled-btn]="viewMode">
        {{ 'interviewSetup.arabic' | translate }}
      </button>
    </div>
  </div>


  <!-- Questions -->
  <div class="question-block" *ngFor="let q of questions; let i = index; trackBy: trackByIndex">

    <div class="field-group">
      <div class="question-header">
        <label class="field-label">{{ i + 1 }}- {{ 'interviewSetup.question' | translate }}</label>
        <button type="button" class="delete-question-btn" *ngIf="questions.length > 1 && !viewMode"
          (click)="removeQuestion(i)">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-trash"
            viewBox="0 0 16 16">
            <path
              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
            <path fill-rule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
          </svg>
        </button>
      </div>
      <input type="text" class="form-input" name="question-{{ i }}" [(ngModel)]="q.question" [disabled]="viewMode" />
    </div>

    <div class="field-group">
      <label class="field-label">{{ 'interviewSetup.clarifications' | translate }}</label>
      <input type="text" class="form-input" name="clarification-{{ i }}" [(ngModel)]="q.clarification"
        [disabled]="viewMode" />
    </div>

    <div class="field-group">
      <label class="field-label">{{ 'interviewSetup.answer' | translate }}</label>
      <input type="text" class="form-input" name="answer-{{ i }}" [(ngModel)]="q.answer" [disabled]="viewMode" />
    </div>

    <div class="field-group">
      <label class="field-label">{{ 'interviewSetup.questionDuration' | translate }}</label>
      <input type="number" class="form-input" name="duration-{{ i }}" [(ngModel)]="q.duration" min="0"
        [placeholder]="'interviewSetup.questionTimeLimitPlaceholder' | translate" [disabled]="viewMode" />
    </div>

  </div>

  <button type="button" class="add-question-btn" (click)="addQuestion()" *ngIf="!viewMode">
    {{ 'interviewSetup.addAnotherQuestion' | translate }} <span class="plus">+</span>
  </button>

  <!-- Timing & Limits -->
  <div class="section">
    <h2 class="interview-section-title">{{ 'interviewSetup.timingLimits' | translate }}</h2>

    <div class="field-group">
      <label class="field-label">{{ 'interviewSetup.totalInterviewTime' | translate }}</label>
      <input type="text" class="form-input" name="totalInterviewTime" [(ngModel)]="totalInterviewTime"
        [placeholder]="'interviewSetup.totalInterviewTimePlaceholder' | translate" [disabled]="viewMode" />
    </div>

    <div class="field-group">
      <label class="field-label">{{ 'interviewSetup.expirationDateLabel' | translate }}</label>
      <input type="date" class="form-input" name="expirationDate" [(ngModel)]="expirationDate" [min]="todayDate"
        [disabled]="viewMode" />
    </div>
  </div>

  <!-- Extra time for answering -->
  <div class="section">
    <h2 class="interview-section-title">{{ 'interviewSetup.extraTimeForAnswering' | translate }}</h2>

    <div class="field-group">
      <label class="field-label">{{ 'interviewSetup.commentTimes' | translate }}</label>
      <div class="radio-group-horizontal">
        <label class="radio-option" [class.disabled]="!isCommentTimeEnabled(1) || viewMode">
          <input type="radio" name="maxAdditionalAnswers" [value]="1" [(ngModel)]="selectedAdditionalAnswers"
            [disabled]="!isCommentTimeEnabled(1) || viewMode">
          <span class="radio-custom"></span>
          <span class="radio-label"><strong>1</strong> {{ 'interviewSetup.minimum3Questions' | translate }}</span>
        </label>
        <label class="radio-option" [class.disabled]="!isCommentTimeEnabled(2) || viewMode">
          <input type="radio" name="maxAdditionalAnswers" [value]="2" [(ngModel)]="selectedAdditionalAnswers"
            [disabled]="!isCommentTimeEnabled(2) || viewMode">
          <span class="radio-custom"></span>
          <span class="radio-label"><strong>2</strong> {{ 'interviewSetup.minimum4Questions' | translate }}</span>
        </label>
        <label class="radio-option" [class.disabled]="!isCommentTimeEnabled(3) || viewMode">
          <input type="radio" name="maxAdditionalAnswers" [value]="3" [(ngModel)]="selectedAdditionalAnswers"
            [disabled]="!isCommentTimeEnabled(3) || viewMode">
          <span class="radio-custom"></span>
          <span class="radio-label"><strong>3</strong> {{ 'interviewSetup.minimum8Questions' | translate }}</span>
        </label>
        <label class="radio-option" [class.disabled]="!isCommentTimeEnabled(5) || viewMode">
          <input type="radio" name="maxAdditionalAnswers" [value]="5" [(ngModel)]="selectedAdditionalAnswers"
            [disabled]="!isCommentTimeEnabled(5) || viewMode">
          <span class="radio-custom"></span>
          <span class="radio-label"><strong>5</strong> {{ 'interviewSetup.minimum15Questions' | translate }}</span>
        </label>
      </div>
    </div>

    <div class="field-group">
      <label class="field-label">{{ 'interviewSetup.commentDuration' | translate }}</label>
      <input type="number" class="form-input" name="additionalAnswerDuration" [(ngModel)]="additionalAnswerDuration"
        min="0" [placeholder]="'interviewSetup.commentDurationPlaceholder' | translate" [disabled]="viewMode || !selectedAdditionalAnswers" />
    </div>
  </div>

  <!-- Plans Design (Just UI, not sent in request) -->

  <!-- Generate Interview Link -->
  <div class="section generate-link-section" *ngIf="!viewMode && !editMode">
    <div class="field-group">
      <label class="field-label">{{ 'interviewSetup.chooseLinkCountLabel' | translate }}</label>
      <input type="number" class="form-input" name="linkCount" [(ngModel)]="selectedLinkCount" min="1"
        placeholder="50" />
    </div>

    <div class="buy-generate-row">
      <button type="button" class="buy-generate-btn" [disabled]="isCreating" (click)="openPaymentModal()">
        <span *ngIf="!isCreating">{{ 'interviewSetup.buyAndGenerate' | translate }} <i
            class="bi bi-arrow-right"></i></span>
        <span *ngIf="isCreating"><i class="bi bi-hourglass-split spin"></i> {{ 'interviewSetup.creating' | translate
          }}</span>
      </button>
    </div>
  </div>
  <div class="section plans-section">
    <div class="plans-container">
      <div class="plan-card">
        <h3 class="plan-title">{{ 'dash.starter' | translate }}</h3>
        <div class="plan-price">$0</div>
        <div class="plan-billing">{{ 'dash.userMo' | translate }}</div>
        <hr class="plan-divider">
        <div class="plan-feature">{{ 'dash.interviewsFeature' | translate:{ count: 50 } }}</div>
        <hr class="plan-divider">
        <button type="button" class="plan-button">{{ 'interviewSetup.selectPlan' | translate }}</button>
        <div class="plan-footer">{{ 'dash.interviewEdits' | translate:{ count: 5 } }}</div>
      </div>
      <div class="plan-card">
        <h3 class="plan-title">{{ 'dash.growth' | translate }}</h3>
        <div class="plan-price">$0</div>
        <div class="plan-billing">{{ 'dash.userMo' | translate }}</div>
        <hr class="plan-divider">
        <div class="plan-feature">{{ 'dash.interviewsFeature' | translate:{ count: 100 } }}</div>
        <hr class="plan-divider">
        <button type="button" class="plan-button">{{ 'interviewSetup.selectPlan' | translate }}</button>
        <div class="plan-footer">{{ 'dash.interviewEdits' | translate:{ count: 5 } }}</div>
      </div>
      <div class="plan-card">
        <h3 class="plan-title">{{ 'dash.business' | translate }}</h3>
        <div class="plan-price">$15</div>
        <div class="plan-billing">{{ 'dash.userMo' | translate }}</div>
        <hr class="plan-divider">
        <div class="plan-feature">{{ 'dash.interviewsFeature' | translate:{ count: 200 } }}</div>
        <hr class="plan-divider">
        <button type="button" class="plan-button">{{ 'interviewSetup.selectPlan' | translate }}</button>
        <div class="plan-footer">{{ 'dash.interviewEdits' | translate:{ count: 5 } }}</div>
      </div>
      <div class="plan-card popular-plan">
        <div class="popular-ribbon">{{ 'interviewSetup.popularPlan' | translate }}</div>
        <h3 class="plan-title">{{ 'dash.professional' | translate }}</h3>
        <div class="plan-price">$35</div>
        <div class="plan-billing">{{ 'dash.userMo' | translate }}</div>
        <hr class="plan-divider">
        <div class="plan-feature">{{ 'dash.interviewsFeature' | translate:{ count: 300 } }}</div>
        <hr class="plan-divider">
        <button type="button" class="plan-button">{{ 'interviewSetup.selectPlan' | translate }}</button>
        <div class="plan-footer">{{ 'dash.interviewEdits' | translate:{ count: 5 } }}</div>
      </div>
      <div class="plan-card">
        <h3 class="plan-title">{{ 'dash.enterprise' | translate }}</h3>
        <div class="plan-price">$15</div>
        <div class="plan-billing">{{ 'dash.userMo' | translate }}</div>
        <hr class="plan-divider">
        <div class="plan-feature">{{ 'dash.interviewsFeature' | translate:{ count: 500 } }}</div>
        <hr class="plan-divider">
        <button type="button" class="plan-button">{{ 'interviewSetup.selectPlan' | translate }}</button>
        <div class="plan-footer">{{ 'dash.interviewEdits' | translate:{ count: 5 } }}</div>
      </div>
    </div>
  </div>

  <!-- Link Count in edit/view mode -->
  <div class="section generate-link-section" *ngIf="viewMode || editMode">
    <div class="field-group">
      <label class="field-label">{{ 'interviewSetup.chooseLinkCountLabel' | translate }}</label>
      <input type="number" class="form-input" name="linkCount" [(ngModel)]="selectedLinkCount"
        [disabled]="viewMode || (editMode && !!selectedJobPostId)" />
    </div>

    <!-- Edit mode: Update button. View mode + unpaid: Buy & Generate button. -->
    <div class="buy-generate-row" *ngIf="editMode || (viewMode && !viewData?.paid)">
      <button type="button" class="buy-generate-btn" [disabled]="isCreating" (click)="openPaymentModal()">
        <span *ngIf="!isCreating && editMode">Update <i class="bi bi-arrow-right"></i></span>
        <span *ngIf="!isCreating && !editMode">{{ 'interviewSetup.buyAndGenerate' | translate }} <i
            class="bi bi-arrow-right"></i></span>
        <span *ngIf="isCreating">
          <i class="bi bi-hourglass-split spin"></i>
          {{ editMode ? ('interviewSetup.updating' | translate) : ('interviewSetup.creating' | translate) }}
        </span>
      </button>
    </div>
  </div>

</div>

<!-- Payment Confirmation Modal -->
<div class="modal-backdrop" *ngIf="showPaymentModal" (click)="closePaymentModal()">
  <div class="modal-card" (click)="$event.stopPropagation()">

    <div class="modal-header">
      <h2 class="modal-title">{{ 'interviewSetup.confirmPaymentTitle' | translate }}</h2>
      <p class="modal-subtitle">{{ 'interviewSetup.confirmPaymentSubtitle' | translate }}</p>
    </div>

    <div class="modal-body">
      <div class="payment-item-card">
        <div class="payment-item-left">
          <span class="payment-icon">⭐</span>
          <div class="payment-item-info">
            <span class="payment-item-name">{{ 'interviewSetup.jobInterviewAmount' | translate }}</span>
            <span class="payment-item-desc">{{ selectedLinkCount }} {{ 'interviewSetup.usesOfLink' | translate }}</span>
          </div>
        </div>
        <span class="payment-price">{{ INTERVIEW_PRICE }} EGP</span>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="modal-cancel-btn" (click)="closePaymentModal()">
        {{ 'interviewSetup.cancel' | translate }}
      </button>
      <button type="button" class="modal-confirm-btn" [disabled]="isCreating" (click)="confirmPayment()">
        <span *ngIf="!isCreating">
          {{ editMode ? 'Update' : ('interviewSetup.confirmAndPay' | translate) }} {{ editMode ? '' : INTERVIEW_PRICE +
          ' EGP' }}
          <i class="bi bi-arrow-right"></i>
        </span>
        <span *ngIf="isCreating">
          <i class="bi bi-hourglass-split spin"></i> {{ 'interviewSetup.creating' | translate }}
        </span>
      </button>
    </div>

  </div>
</div>